import common from '../common';

export default {
  jpath: ['spectra', 'xrd'],
  find: common.basenameFind,
  getProperty: common.getTargetProperty,
  process: common.getMetaFromJcamp,
};
